import { LatestTopBarComponent } from './latest-top-bar/latest-top-bar.component';
import { AuthlayoutComponent } from "./layout/authlayout/authlayout.component";
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
// import { NavbarComponent } from "./navbar/navbar.component";
import { SidebarComponent } from "./sidebar/sidebar.component";
import { LayoutComponent } from "./layout/layout.component";
import { RouterModule } from "@angular/router";
import { AppUrlsService } from "./services/app-urls.service";
import { AuthGuard } from "./services/auth-guard.service";
import { AuthService } from "./services/auth.service";
import { AppHttpClient } from "./services/http-client.service";
import { HttpClientModule } from "@angular/common/http";
import {
  ToastrModule,
  ToastNoAnimation,
  ToastNoAnimationModule,
} from "ngx-toastr";
import { NavBarDataService } from "./services/navbar.service";
import { WnDropdownComponent } from "./wn-dropdown/wn-dropdown.component";
import { FormsModule } from "@angular/forms";
import { SidebarService } from "./services/sidebar.service";
import { SharedDataService } from "../IoTCore/dashboard-builder/services/shared.service";
import { LoaderComponent } from "./loadersManager/loaders/loader-primary.component";
import { SharedRoutingModule } from "./shared-routing.module";
import { SpinnerLoader } from "./SpinnerLoader/spinner-loader.component";
import { NavbarComponent } from './navbar/navbar.component';
// import { TopBarComponent } from "./top-bar/top-bar.component";
// import {
//   MqttModule,
//   IMqttServiceOptions
// } from 'ngx-mqtt';


// export const MQTT_SERVICE_OPTIONS: IMqttServiceOptions = {
//   hostname: '107.23.242.194',
//   port: 8090,
//   protocol: "wss",
//   path: '/mqtt'
// };

@NgModule({
  declarations: [
    NavbarComponent,
    LatestTopBarComponent,
    SidebarComponent,
    LayoutComponent,
    AuthlayoutComponent,
    WnDropdownComponent,
    SpinnerLoader,
    // LoaderComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    HttpClientModule,
    ToastNoAnimationModule,
    FormsModule,
    SharedRoutingModule,
    // MqttModule.forRoot(MQTT_SERVICE_OPTIONS),
    ToastrModule.forRoot({
      toastComponent: ToastNoAnimation,
      iconClasses: {},
      titleClass: "fx-toastr-title",
      progressBar: false,
      closeButton: true,
    }),
  ],
  exports: [SpinnerLoader],
  providers: [
    AppUrlsService,
    AuthGuard,
    AuthService,
    AppHttpClient,
    NavBarDataService,
    SidebarService,
    SharedDataService
  ],
})
export class SharedModule {}
